import styled from 'styled-components/native';

export const Container = styled.View`
`;

export const Content = styled.View`
  flex-direction: row;
`;

export const ViewIcon = styled.View`
  position: absolute;
  z-index: 99;
  height: 11.8rem; //aprox altura do card
  justify-content: center;
  overflow: hidden;
  background-color: rgba(255,255,255,0.1);
  border-radius: 5px;
  cursor: pointer;
  width: 1.5rem;
`;

export const ViewTextInput = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`;

export const ViewText = styled.View`
  justify-content: center;
`;

export const ViewOrder = styled.View`
  justify-content: center;
  width: 10%;
  margin:0rem 0.5rem;
`;

export const ViewButton = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0.3rem 1rem 0rem 1rem;
  justify-content: flex-start;
`;

export const ContentIcon = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 0.4rem;
  border-radius: 30px;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '')};
`;

export const HeaderRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-right: 1rem;
  /* Acima da linha de botões (irmã seguinte), senão o tooltip dos ícones do
     cabeçalho é pintado atrás dela. */
  z-index: 2;
`;

export const SeeMoreButton = styled.TouchableOpacity`
  padding: 0.25rem 0.5rem;
`;

export const SeeMoreContainer = styled.View`
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0.5rem;
  padding-right: 1rem;
`;

/** Mesmo padrão de scroll da Main (`pages/Main/style.js` → Container). */
export const ModalScroll = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  keyboardShouldPersistTaps: 'handled',
  contentContainerStyle: {
    flexDirection: 'column',
    flexBasis: 'auto',
    padding: 16,
    paddingBottom: 24,
  },
})`
  flex: 1;
`;

export const ModalContent = styled.View`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '#ffffff')};
  border-radius: 0px;
`;

export const ModalHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`;

export const ModalListItem = styled.View`
  margin-bottom: 0.75rem;
`;